/* Peacock Life — Luxe homepage storytelling.
   Scroll-scrubbed sections (hero film, manifesto orbit, category stack, product rail),
   in-view reels, a section index and a desktop cursor. Everything is additive: until
   this file boots (html.lxh-on) the page renders as plain, fully visible content.
   Each frame reads all geometry first, then writes, so the browser never lays out twice. */
(function () {
  'use strict';
  if (window.__luxeHome) return;
  window.__luxeHome = true;

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FINE = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var html = document.documentElement;
  if (!REDUCED) html.classList.add('lxh-on');

  function clamp(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
  function qa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function isMobile() { return window.innerWidth < 750; }

  /* A stable viewport height: phone toolbars change innerHeight while scrolling, which would
     make every pinned section jump. Only a width change (rotation, real resize) updates it. */
  var VW = window.innerWidth, VH = window.innerHeight;

  var scrubs = [], rails = [], cats = [], nav = null, chapters = [];

  /* ---------- word split for the manifesto ---------- */
  function splitWords(root) {
    var out = [];
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (ch) {
        if (ch.nodeType === 3) {
          var frag = document.createDocumentFragment();
          ch.textContent.split(/(\s+)/).forEach(function (p) {
            if (!p) return;
            if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(p)); return; }
            var s = document.createElement('span');
            s.className = 'lxh-w';
            s.textContent = p;
            out.push(s);
            frag.appendChild(s);
          });
          node.replaceChild(frag, ch);
        } else if (ch.nodeType === 1) { walk(ch); }
      });
    })(root);
    return out;
  }

  /* ---------- measurements (only on load and real resizes) ---------- */
  function measureRail(r) {
    var desk = window.innerWidth >= 990 && !REDUCED;
    r.el.classList.toggle('is-pinned', desk);
    if (!desk) { r.track.style.height = ''; r.dist = 0; r.row.style.removeProperty('--x'); return; }
    r.dist = Math.max(0, r.row.scrollWidth - window.innerWidth);
    r.track.style.height = (window.innerHeight + r.dist) + 'px';
  }
  var ROT = [-9, 5, -4, 8, -6, 3];
  function measureCats(grid) {
    var cs = qa('.lxh-cat', grid);
    var w = grid.clientWidth, h = grid.clientHeight;
    var pos = cs.map(function (c) { return [c.offsetLeft + c.offsetWidth / 2, c.offsetTop + c.offsetHeight / 2]; });
    cs.forEach(function (c, i) {
      c.style.setProperty('--dx', (w / 2 - pos[i][0]).toFixed(1) + 'px');
      c.style.setProperty('--dy', (h / 2 - pos[i][1]).toFixed(1) + 'px');
      c.style.setProperty('--r', ROT[i % ROT.length] + 'deg');
      c.style.setProperty('--z', String(20 - i));
    });
  }
  function measureAll() { rails.forEach(measureRail); cats.forEach(measureCats); kick(); }

  /* ---------- loop ---------- */
  var ticking = false;
  function frame() {
    ticking = false;
    var vh = VH || 1, i;
    /* READ everything first */
    var sr = [];
    for (i = 0; i < scrubs.length; i++) sr.push(scrubs[i].getBoundingClientRect());
    var rr = [];
    for (i = 0; i < rails.length; i++) {
      var rl = rails[i];
      rr.push(rl.dist ? rl.track.getBoundingClientRect().top : [rl.row.scrollLeft, rl.row.scrollWidth - rl.row.clientWidth]);
    }
    var cr = null;
    if (nav) { cr = []; for (i = 0; i < chapters.length; i++) cr.push(chapters[i].getBoundingClientRect()); }

    /* then WRITE */
    for (i = 0; i < scrubs.length; i++) {
      var s = scrubs[i], r = sr[i];
      if (r.bottom < -vh || r.top > vh * 2) continue;
      var span = r.height - vh;
      var p = span > 0 ? clamp(-r.top / span) : clamp((vh - r.top) / (vh + r.height));
      if (s._p === p) continue;
      s._p = p;
      s.style.setProperty('--p', p.toFixed(4));
      if (s._words) {
        var n = s._words.length, lit = Math.round(n * clamp((p - .06) / .6));
        if (lit !== s._lit) {
          for (var w = 0; w < n; w++) s._words[w].classList.toggle('is-lit', w < lit);
          s._lit = lit;
        }
      }
      if (s._hero) s._hero.classList.toggle('is-open', p > .55);
    }
    for (i = 0; i < rails.length; i++) {
      var rl2 = rails[i], v = rr[i];
      if (!rl2.dist) {
        rl2.el.style.setProperty('--p', v[1] > 0 ? (v[0] / v[1]).toFixed(4) : '0');
        continue;
      }
      var pr = clamp(-v / rl2.dist);
      rl2.row.style.setProperty('--x', (pr * rl2.dist).toFixed(1));
      rl2.el.style.setProperty('--p', pr.toFixed(4));
    }
    if (cr) {
      var cur = -1, half = window.innerHeight * .5;
      for (i = 0; i < cr.length; i++) if (cr[i].top <= half && cr[i].bottom > half) cur = i;
      nav.classList.toggle('is-on', cur > 0);
      for (var j = 0; j < nav.children.length; j++) nav.children[j].classList.toggle('is-cur', j === cur);
      nav.classList.toggle('is-dark', cur >= 0 && (chapters[cur].classList.contains('lxb--dark') || chapters[cur].hasAttribute('data-dark')));
    }
  }
  function kick() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }

  /* ---------- section index (wide desktops only) ---------- */
  function buildNav() {
    if (REDUCED || window.innerWidth < 1280) return;
    chapters = qa('[data-chapter]');
    if (chapters.length < 3) return;
    nav = document.createElement('nav');
    nav.className = 'lxh-nav';
    nav.setAttribute('aria-label', 'Sections');
    chapters.forEach(function (c, i) {
      if (!c.id) c.id = 'lxh-ch-' + (i + 1);
      var a = document.createElement('a');
      a.href = '#' + c.id;
      a.innerHTML = '<span></span><i></i>';
      a.firstChild.textContent = c.getAttribute('data-chapter');
      a.addEventListener('click', function (e) {
        e.preventDefault();
        window.scrollTo({ top: c.getBoundingClientRect().top + window.scrollY, behavior: 'smooth' });
      });
      nav.appendChild(a);
    });
    document.body.appendChild(nav);
  }

  /* ---------- hero film: always autoplay, muted, inline ---------- */
  function initHero(sec) {
    var v = sec.querySelector('video');
    if (!v) return;
    v.muted = true; v.defaultMuted = true;
    v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', '');
    v.removeAttribute('controls');
    function pickSrc() {
      var m = v.getAttribute('data-src-m'), d = v.getAttribute('data-src-d');
      return (isMobile() && m) ? m : d;
    }
    function load() {
      var src = pickSrc();
      if (!src || v.getAttribute('src') === src) return;
      var poster = v.getAttribute(isMobile() ? 'data-poster-m' : 'data-poster-d');
      if (poster) v.setAttribute('poster', poster);
      v.setAttribute('src', src);
      v.load();
    }
    function play() { var pp = v.play(); if (pp && pp.catch) pp.catch(function () {}); }
    load();
    play();
    v.addEventListener('loadeddata', play);
    v.addEventListener('canplay', play);
    /* iOS Low Power Mode and some Android data savers refuse autoplay until the first gesture */
    function nudge() { if (v.paused && inView) play(); }
    ['touchstart', 'pointerdown', 'scroll', 'keydown'].forEach(function (ev) {
      window.addEventListener(ev, nudge, { passive: true });
    });
    document.addEventListener('visibilitychange', function () { if (!document.hidden && inView) play(); });
    var inView = true;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { inView = e.isIntersecting; if (inView) play(); else v.pause(); });
      }, { threshold: 0 }).observe(sec);
    }
    sec._reload = function () { load(); if (inView) play(); };
  }

  /* ---------- reels: on phones only the most visible film plays ---------- */
  var SND_OFF = '<svg width="15" height="15" viewBox="0 0 20 20" fill="none"><path d="M3 7.5h3l4-3.5v12l-4-3.5H3v-5Z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/><path d="m13.5 7.5 4 5m0-5-4 5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>';
  var SND_ON = '<svg width="15" height="15" viewBox="0 0 20 20" fill="none"><path d="M3 7.5h3l4-3.5v12l-4-3.5H3v-5Z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/><path d="M13.5 7a4 4 0 0 1 0 6M15.8 4.8a7 7 0 0 1 0 10.4" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>';
  function initReels(sec) {
    var vids = qa('video', sec);
    vids.forEach(function (v) {
      v.muted = true; v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.loop = true; v.removeAttribute('controls');
      var btn = v.parentNode.querySelector('.lxh-reel__snd');
      if (btn) btn.addEventListener('click', function () {
        var turnOn = v.muted;
        vids.forEach(function (o) { o.muted = true; });
        qa('.lxh-reel__snd', sec).forEach(function (b) { b.innerHTML = SND_OFF; b.setAttribute('aria-pressed', 'false'); });
        v.muted = !turnOn;
        if (turnOn) v.play().catch(function () {});
        btn.setAttribute('aria-pressed', turnOn ? 'true' : 'false');
        btn.innerHTML = turnOn ? SND_ON : SND_OFF;
      });
    });
    if (REDUCED || !('IntersectionObserver' in window)) return;
    var ratio = new Map();
    function settle() {
      var best = null, bestR = 0;
      vids.forEach(function (v) { var r = ratio.get(v) || 0; if (r > bestR) { bestR = r; best = v; } });
      vids.forEach(function (v) {
        var r = ratio.get(v) || 0;
        var on = isMobile() ? (v === best && r >= .5) : r >= .35;
        if (on) { if (v.preload === 'none') v.preload = 'auto'; if (v.paused) v.play().catch(function () {}); }
        else if (!v.paused) v.pause();
      });
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { ratio.set(e.target, e.isIntersecting ? e.intersectionRatio : 0); });
      settle();
    }, { threshold: [0, .35, .5, .75, 1] });
    vids.forEach(function (v) { io.observe(v); });
  }

  /* ---------- desktop cursor ---------- */
  function initCursor() {
    if (!FINE || REDUCED || document.querySelector('.lxh-cursor')) return;
    var c = document.createElement('div');
    c.className = 'lxh-cursor';
    c.innerHTML = '<span></span>';
    document.body.appendChild(c);
    var label = c.firstChild, x = -100, y = -100, tx = -100, ty = -100, raf = 0, lastT = null;
    function loop() {
      x += (tx - x) * .2; y += (ty - y) * .2;
      c.style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0)';
      raf = (Math.abs(tx - x) + Math.abs(ty - y) > .3) ? requestAnimationFrame(loop) : 0;
    }
    document.addEventListener('mousemove', function (e) {
      tx = e.clientX; ty = e.clientY;
      c.classList.add('is-on');
      var t = e.target.closest ? e.target.closest('[data-cursor], a, button') : null;
      if (t !== lastT) {
        lastT = t;
        var view = t && t.hasAttribute('data-cursor');
        c.classList.toggle('is-view', !!view);
        c.classList.toggle('is-link', !!t && !view);
        label.textContent = view ? t.getAttribute('data-cursor') : '';
      }
      if (!raf) raf = requestAnimationFrame(loop);
    }, { passive: true });
    document.addEventListener('mouseleave', function () { c.classList.remove('is-on'); });
  }

  var heroes = [];
  function boot() {
    qa('[data-lxh-scrub]:not([data-lxh-init])').forEach(function (s) {
      s.setAttribute('data-lxh-init', '');
      if (REDUCED) return;
      var t = s.querySelector('[data-lxh-words]');
      if (t) { s._words = splitWords(t); t.classList.add('is-scrub'); }
      s._hero = s.closest('.lxh-hero');
      scrubs.push(s);
    });
    qa('[data-lxh-rail]:not([data-lxh-init])').forEach(function (el) {
      el.setAttribute('data-lxh-init', '');
      var r = { el: el, track: el.querySelector('.lxh-rail__track'), row: el.querySelector('.lxh-rail__row'), dist: 0 };
      if (!r.track || !r.row) return;
      r.row.addEventListener('scroll', kick, { passive: true });
      rails.push(r);
    });
    qa('.lxh-cats__grid:not([data-lxh-init])').forEach(function (g) { g.setAttribute('data-lxh-init', ''); cats.push(g); });
    qa('[data-lxh-hero]:not([data-lxh-init])').forEach(function (s) { s.setAttribute('data-lxh-init', ''); heroes.push(s); initHero(s); });
    qa('[data-lxh-reels]:not([data-lxh-init])').forEach(function (s) { s.setAttribute('data-lxh-init', ''); initReels(s); });
    var ins = qa('[data-lxh-in]:not(.is-in)');
    if (REDUCED || !('IntersectionObserver' in window)) ins.forEach(function (s) { s.classList.add('is-in'); });
    else {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -18% 0px' });
      ins.forEach(function (s) { io.observe(s); });
    }
    if (!nav) buildNav();
    initCursor();
    measureAll();
  }

  function onResize() {
    if (window.innerWidth === VW) { kick(); return; } /* toolbar show/hide: ignore */
    VW = window.innerWidth; VH = window.innerHeight;
    heroes.forEach(function (h) { if (h._reload) h._reload(); });
    measureAll();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('load', measureAll);
  window.addEventListener('scroll', kick, { passive: true });
  window.addEventListener('resize', onResize, { passive: true });
  window.addEventListener('orientationchange', function () { setTimeout(function () { VW = -1; onResize(); }, 250); });
  document.addEventListener('shopify:section:load', boot);
})();
